import { configureStore } from "@reduxjs/toolkit";
import Cart_System from "../Redux/Cart_System";
import user_information from "../Redux/user_information";

export default configureStore({
    reducer:{
        cart:Cart_System,
        user:user_information,
    }
})